import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteReasonRemarkComponent } from 'src/app/Account/delete-reason-remark/delete-reason-remark.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Loan } from 'src/model/loan.model';
import { Receipt } from 'src/model/loanReceipt.model';
import { Transaction } from 'src/model/transaction.model';
import { TransactionType } from 'src/model/transactionType.model';

@Component({
    selector: 'app-loan-details',
    templateUrl: './loan-details.component.html',
    styleUrls: ['./loan-details.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class LoanDetailsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);

  isDirty = false;

  @Input() selectedLoan: Loan;
  receiptList: Receipt[] = [];
  transactionTypeList: TransactionType[] = [];

  @Input() isDeletable = true;

  ngOnInit(): void {
    this.getAllTransactionsOfLoan()
  }

  confirmDeleteTranscation(transaction: Transaction) {
    const timeDiff = new Date().getTime() - new Date(transaction.Date).getTime();
    const dateDiff = timeDiff / (1000 * 3600 * 24);
    if (dateDiff < 90 || this.sharedService.isBossAccount() == true) {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
      modalRef.componentInstance.message = "Deleting loan transaction might cause deleting receipt, loan and other related entity. Are you sure to do so?";
      modalRef.result.then((confirm) => {
        if (confirm) {
          const modalRef = this.sharedService.openModal(DeleteReasonRemarkComponent);
          modalRef.componentInstance.transaction = transaction;
          modalRef.componentInstance.passEntry.subscribe((entry) => {
            const remark = entry;

            //append added account to account list
            this.deleteTransaction(remark, transaction.ID);
          });
        }
      });
    } else
      this.sharedService.openAlert("This transaction is too old, please contact your admin to delete", ALERT_TYPE.DANGER);
  }

  deleteTransaction(remark: string, transactionID: number) {
    const data =
    {
      "reason": remark
    };

    const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteLoanTransaction(transactionID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.removeTransctionFromList(transactionID);
          this.isDirty = true;
        }
        else {
          // this.sharedService.openAlert("Opps, some errors occured. Please try again later");
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  removeTransctionFromList(transactionId: number) {
    for (let i = 0; i < this.receiptList.length; i++) {
      for (let j = 0; j < this.receiptList[i].Transactions.length; j++) {
        if (Number(this.receiptList[i].Transactions[j].ID) == transactionId) {
          this.receiptList[i].Transactions.splice(j, 1);
          this.cdr.detectChanges();

          if (this.receiptList.length == 1 && this.receiptList[0].Transactions.length == 0)
            window.location.reload();
        }
      }
    }
    return -1
  }

  getAllTransactionsOfLoan() {
    const xhttp = this.restApi.getRequest(this.constructApi.getLoanReceipts(this.selectedLoan.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const receiptArray = JSON.parse((xhttp.responseText));

        const loanTransactionList: Transaction[] = [];
        receiptArray.forEach(receipt => {
          const loanTransactionList: Transaction[] = [];
          const transactionArray = JSON.parse(JSON.stringify(receipt.transactions));

          transactionArray.forEach(transaction => {
            const record = new Transaction(transaction.id, transaction.remark, transaction.amount,
              transaction.closingBalance, transaction.accountId, transaction.date, transaction.type, transaction.handleBy, undefined, undefined, undefined, undefined, undefined, transaction.subtype)

            loanTransactionList.push(record);
          });

          const receiptObj = new Receipt(receipt.id, receipt.number, loanTransactionList);
          this.receiptList.push(receiptObj);
        });
      }
    };
  }

  // calculateTransactionAmount() {
  //   var sum = 0;

  //   for (let i = 0; i < this.receiptList.length; i++) {
  //     for (let j = 0; j < this.receiptList[i].Transactions.length; j++) {
  //       sum += this.receiptList[i].Transactions[j].Amount;
  //     }
  //   }
  //   return sum;
  // }

  checkAmountInOut(amount: number) {
    if (amount < 0)
      return 'negative';
    else
      return 'positive';
  }

  reset() {
    if (this.isDirty == true) {
      window.location.reload();
    }
    else
      this.activeModal.close();
  }
}
